<template>
  <v-card class="CardDetails mb-4" text elevation="0">
    <v-card-title class="pa-0 pb-4">
      {{title}} {{$t("CardDetails.lotDetails")}} "{{location.name}}"
      <v-tooltip right nudge-bottom="55">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="ml-2" :size="18" color="#757575">info_outline</v-icon>
        </template>
        <p
          v-for="key in getDescriptionKeys"
          :key="key"
          class="mb-0"
        >
          <span style="font-weight: 300; font-size: 14px !important;">{{descriptionLabels[key]}}:</span>
          <span style="font-weight: 400; font-size: 14px !important;">{{getDescriptionItem(key)}}</span>
        </p>
      </v-tooltip>
    </v-card-title>
    <v-container fluid class="Content d-flex pa-0">
      <v-row dense class="Data fill-height">
        <v-flex
          v-for="key in getVisualInfoItemsKeys"
          :key="key"
          :class="key === 'application_rate' ? 'xs5' : (key === 'num_faults' ? 'xs3' : 'xs4')"
          class="DataItem pr-2 d-flex"
        >
          <div>
            <v-avatar :class="getIconColor(key)">
              <v-icon dark>{{visualInfoItems[key].icon(getDetailsItem(key))}}</v-icon>
            </v-avatar>
          </div>
          <div>
            <p class="display-1 mb-0">
              {{getDetailsItem(key)}}
              <span v-if="visualInfoItems[key].suf" class="title ma-0 ml-1">{{visualInfoItems[key].suf}}</span>
            </p>
            <p class="subheading ma-0">{{visualInfoItems[key].label}}</p>
            <p v-if="key === 'application_rate' && getDetailsItem('accumulated_application_rate') !== '-'">
              <span class="subheading ma-0" style="font-weight: 400">{{getDetailsItem('accumulated_application_rate')}} {{$t("CardDetails.mmUnit")}}</span>
              <span class="subheading ma-0">{{$t("CardDetails.accumulated")}}</span>
            </p>
            <!-- accumulated_application_rate -->
          </div>
        </v-flex>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  data () {
    const getVisualInfoItems = () => ({
      application_rate: {
        suf: this.$t('CardDetails.mmUnit'),
        label: this.$t('CardDetails.applicationRate'),
        icon: () => 'opacity',
        iconColor: () => 'blue-gradient'
      },
      completed_passes: {
        label: this.$t('CardDetails.completedPasses'),
        icon: () => 'settings_backup_restore',
        iconColor: () => 'purple-gradient'
      },
      irrigation_hours: {
        suf: this.$t('CardDetails.hsUnit'),
        label: this.$t('CardDetails.irrigationHours'),
        icon: () => 'hourglass_bottom',
        iconColor: () => 'purple-gradient'
      },
      num_faults: {
        label: this.$t('CardDetails.faults'),
        icon: (val) => val === '0' ? 'check' : 'report_problem',
        iconColor: (val) => val === '0' ? 'green-gradient' : 'red-gradient'
      },
      average_pressure: {
        suf: this.$t('CardDetails.barUnit'),
        label: this.$t('CardDetails.averagePressure'),
        icon: () => 'speed',
        iconColor: ({value, bookPres}) => {
          if (!isNaN(value) && !isNaN(bookPres)) {
            return (value >= (bookPres - 0.5)) && (value <= (bookPres + 0.5)) ? 'green-gradient' : 'red-gradient'
          }
          return 'grey'
        }
      }
    })
    const getDescriptionLabels = () => ({
      // model: 'Modelo',
      crop: this.$t('CardDetails.crop'),
      num_pumps: this.$t('CardDetails.numberOfPumps'),
      field: this.$t('CardDetails.field'),
      area: this.$t('CardDetails.area'),
      zone: this.$t('CardDetails.zone'),
      watering_employee: this.$t('CardDetails.irrigator')
    })
    const crops = {
      corn: this.$t('CardDetails.corn'),
      sunflower: this.$t('CardDetails.sunflower'),
      soy: this.$t('CardDetails.soy'),
      wheat: this.$t('CardDetails.wheat'),
      peanut: this.$t('CardDetails.peanut'),
      alfalfa: this.$t('CardDetails.alfalfa'),
      barley: this.$t('CardDetails.barley'),
      cotton: this.$t('CardDetails.cotton'),
      clover: this.$t('CardDetails.clover'),
      potato: this.$t('CardDetails.potato'),
      sugar_cane: this.$t('CardDetails.sugarCane'),
      ryegrass: this.$t('CardDetails.ryegrass'),
      rape: this.$t('CardDetails.rape'),
      rice: this.$t('CardDetails.rice'),
      pea: this.$t('CardDetails.pea'),
      oatmeal: this.$t('CardDetails.oatmeal'),
      carinata: this.$t('CardDetails.carinata'),
      rye: this.$t('CardDetails.rye'),
      chickpea: this.$t('CardDetails.chickpea'),
      sunflower_seed: this.$t('CardDetails.sunflowerSeed'),
      seed_corn: this.$t('CardDetails.seedCorn'),
      moha: this.$t('CardDetails.moha'),
      millet: this.$t('CardDetails.millet'),
      flax: this.$t('CardDetails.flax'),
      lentil: this.$t('CardDetails.lentil'),
      seed_potato: this.$t('CardDetails.seedPotato'),
      kidney_bean: this.$t('CardDetails.kidneyBean'),
      sorghum: this.$t('CardDetails.sorghum'),
      vicia: this.$t('CardDetails.vicia'),
      carrot: this.$t('CardDetails.carrot'),
      onion: this.$t('CardDetails.onion'),
      beet: this.$t('CardDetails.beet'),
      not_specified: this.$t('CardDetails.notSpecified')
    }
    return {
      visualInfoItems: getVisualInfoItems(),
      descriptionLabels: getDescriptionLabels(),
      crops
    }
  },
  props: ['location', 'title'],
  computed: {
    getDescriptionKeys () {
      const keys = []
      for (let key in this.descriptionLabels) {
        keys.push(key)
      }
      return keys
    },
    getVisualInfoItemsKeys () {
      const keys = []
      for (let key in this.visualInfoItems) {
        keys.push(key)
      }
      return keys
    }
  },
  methods: {
    getDescriptionItem (key) {
      const description = this.location.details.description
      if (description && description[key]) {
        if (key === 'area') {
          return description[key].toFixed(1) + ' ha'
        }
        if (key === 'crop') {
          return this.crops[description[key]] || '-'
        }
        return description[key]
      } else {
        return '-'
      }
    },
    getDetailsItem (key, raw = false) {
      const parseToReturn = (value) => {
        return raw ? parseFloat(value) : parseFloat(value).toFixed(1).replace(/\.0+$/, '')
      }

      const detailsData = this.location.details.data
      return (detailsData && (detailsData[key] || detailsData[key] === 0))
        ? parseToReturn(detailsData[key])
        : '-'
    },
    getIconColor (key) {
      if (key === 'average_pressure') {
        const val = {
          value: parseFloat(this.getDetailsItem(key, true)),
          bookPres: parseFloat(this.location.circularGraphics.book_pressure)
        }
        return this.visualInfoItems[key].iconColor(val)
      }
      return this.visualInfoItems[key].iconColor(this.getDetailsItem(key))
    }
  }
}
</script>


// WEBPACK FOOTER //
// CardDetails.vue?1a0a921c